module.exports = __webpack_public_path__ + "img/main.3d45a435.png";